// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__PZY6T","summary":"CartItem_summary__2rLVR","price":"CartItem_price__m0fJe","amount":"CartItem_amount__8plEM","actions":"CartItem_actions__3bKir"};